import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SvgIcon = ({ iconName, className, size }) => (
    <svg
        className={classNames(
            'bs-icon',
            className,
            { [`bs-icon_size${size}`]: size },
        )}
    >
        <use xlinkHref={`#betslip-icon-${iconName}`} />
    </svg>
);

SvgIcon.defaultProps = {
    className: '',
    size: '',
};

SvgIcon.propTypes = {
    iconName: PropTypes.string.isRequired,
    size: PropTypes.string,
    className: PropTypes.string,
};

export default SvgIcon;



// WEBPACK FOOTER //
// /src/js/common/svgIcon/SvgIcon.jsx